import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca0b900a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "whitespace-nowrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 whitespace-nowrap" }, "Số lượng", -1))
const _hoisted_3 = { class: "text-end mb-0 whitespace-nowrap font-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 whitespace-nowrap" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Đơn giá ")
], -1))
const _hoisted_5 = { class: "text-end mb-0 whitespace-nowrap font-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Thành tiền ")
], -1))
const _hoisted_7 = { class: "text-end mb-0 whitespace-nowrap font-bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center" }, "Tái SD", -1))
const _hoisted_9 = { class: "mb-0 text-end d-flex align-items-center justify-content-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center" }, "Mất", -1))
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center" }, "Số Lg", -1))
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center" }, "Quy đổi (Kg)", -1))
const _hoisted_15 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 d-flex align-items-center" }, "Mã VT", -1))
const _hoisted_17 = { class: "truncate block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Lý do")
], -1))
const _hoisted_19 = { class: "flex flex-col justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VatTuDetailModal = _resolveComponent("VatTuDetailModal")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VatTuDetailModal, {
      "vat-tu-id": _ctx.selectedVatTuId,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedVatTuId = undefined)),
      onRefresh: _cache[1] || (_cache[1] = 
      () => {
        _ctx.selectedVatTuId = undefined;

        _ctx.$emit('refresh');
      }
    )
    }, null, 8, ["vat-tu-id"]),
    _createVNode(_component_el_table, {
      border: true,
      "cell-class-name": _ctx.isTextDangerColumn,
      data: _ctx.items,
      "empty-text": _ctx.emptyText,
      size: "medium"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "50"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(scope.$index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_word_break_column, {
          "header-title": "Tên vật tư",
          "min-width": "200",
          property: "ten_vat_tu"
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã VT",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "ĐVT",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.don_vi_tinh ?? "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "150" }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.formatQuantity(scope.row.pivot.so_luong)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "180" }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.donGiaDisplay(scope.$index)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "180" }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.thanhTienDisplay(scope.$index)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Thu hồi",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.items[scope.$index].thu_hoi,
              "onUpdate:modelValue": ($event: any) => ((_ctx.items[scope.$index].thu_hoi) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "C/ty quản lý",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.items[scope.$index].cong_ty_duyet,
              "onUpdate:modelValue": ($event: any) => ((_ctx.items[scope.$index].cong_ty_duyet) = $event),
              disabled: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        (_ctx.showThuHoiColumns)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Vật tư phụ tùng phải thu hồi",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  "min-width": "100",
                  "show-overflow-tooltip": ""
                }, {
                  header: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx((scope) => [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.items[scope.$index]?.thu_hoi
                ? _ctx.thuHoiData[scope.$index]?.tai_sd ?? 0
                : "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "100",
                  "show-overflow-tooltip": ""
                }, {
                  header: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx((scope) => [
                    (_ctx.thuHoiData[scope.$index])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_el_input_number, {
                            style: {"width":"100%"},
                            type: "number",
                            min: 0,
                            controls: false,
                            disabled: !_ctx.items[scope.$index].thu_hoi,
                            modelValue: _ctx.thuHoiData[scope.$index].mat,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.thuHoiData[scope.$index].mat) = $event),
                            onChange: (value) => _ctx.onMatChanged(scope.$index, value),
                            onBlur: 
                () => _ctx.onMatChanged(scope.$index, _ctx.thuHoiData[scope.$index].mat)
              ,
                            onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select())),
                            onWheel: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Phế liệu",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      "min-width": "100",
                      "show-overflow-tooltip": ""
                    }, {
                      header: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx((scope) => [
                        (_ctx.thuHoiData[scope.$index])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_el_input_number, {
                                style: {"width":"100%"},
                                type: "number",
                                min: 0,
                                controls: false,
                                disabled: !_ctx.items[scope.$index].thu_hoi,
                                modelValue: _ctx.thuHoiData[scope.$index].so_luong_phe_lieu,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.thuHoiData[scope.$index].so_luong_phe_lieu) = $event),
                                onChange: 
                  (value) => _ctx.onSoLuongPheLieuChanged(scope.$index, value)
                ,
                                onBlur: 
                  () =>
                    _ctx.onSoLuongPheLieuChanged(
                      scope.$index,
                      _ctx.thuHoiData[scope.$index].so_luong_phe_lieu
                    )
                ,
                                onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select())),
                                onWheel: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      "min-width": "120",
                      "show-overflow-tooltip": ""
                    }, {
                      header: _withCtx(() => [
                        _hoisted_14
                      ]),
                      default: _withCtx((scope) => [
                        (_ctx.thuHoiData[scope.$index])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_input_number, {
                                style: {"width":"100%"},
                                type: "number",
                                min: 0,
                                controls: false,
                                disabled: 
                  !_ctx.items[scope.$index].thu_hoi ||
                  _ctx.thuHoiData[scope.$index].so_luong_phe_lieu === 0
                ,
                                class: _normalizeClass({
                  'is-error':
                    _ctx.thuHoiData[scope.$index].so_luong_phe_lieu > 0 &&
                    _ctx.thuHoiData[scope.$index].quy_doi_kg === 0,
                }),
                                modelValue: _ctx.thuHoiData[scope.$index].quy_doi_kg,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.thuHoiData[scope.$index].quy_doi_kg) = $event),
                                onChange: (value) => _ctx.onQuyDoiKgChanged(scope.$index, value),
                                onBlur: 
                  () =>
                    _ctx.onQuyDoiKgChanged(
                      scope.$index,
                      _ctx.thuHoiData[scope.$index].quy_doi_kg
                    )
                ,
                                onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select())),
                                onWheel: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                              }, null, 8, ["disabled", "class", "modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      "min-width": "120",
                      "show-overflow-tooltip": ""
                    }, {
                      header: _withCtx(() => [
                        _hoisted_16
                      ]),
                      default: _withCtx((scope) => [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.thuHoiData[scope.$index]?.ma_vt_thu_hoi || "-"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showLyDoColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              width: "300"
            }, {
              header: _withCtx(() => [
                _hoisted_18
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_input, {
                    modelValue: scope.row.pivot.ghi_chu,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.pivot.ghi_chu) = $event),
                    type: "textarea",
                    rows: "1",
                    onInput: (value) => _ctx.handleGhiChuInput({ id: scope.row.id, value })
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.items.length)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              fixed: "right",
              width: "50",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_Setting, {
                  actions: _ctx.getSettingActions(scope.row)
                }, null, 8, ["actions"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["cell-class-name", "data", "empty-text"])
  ], 64))
}